<template name="dialog">
  <div class="dialog" v-if="value">
    <div class="dialog-outer">
      <div class="dialog-text">
        <slot />
      </div>
      <div class="dialog-actions">
        <button type="button" class="btn btn-submit" @click="submitHandler">{{submitLabel}}</button>
        <button type="button" class="btn btn-cancel" @click="cancelHandler">취소</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    submitLabel: {
      type: String,
      default: '종료'
    }
  },
  methods: {
    submitHandler () {
      this.$emit('submit')
    },
    cancelHandler () {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
  .dialog {
    position: fixed;
    top: 0; bottom: 0; left: 0; right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,0.2);
    z-index: 150;

    .dialog-outer {
      width: 100%;
      max-width: 312px;
      padding: 24px;
      background-color: white;
      border-radius: 8px;
      box-shadow: 0px 3px 0px rgba(0,0,0,0.3);
    }

    .dialog-text {
      font-size: 16px;
      color: black;
      text-align: center;
    }

    .dialog-actions {
      text-align: center;
    }

    .btn {
      width:64px;
      height:36px;
      border-radius:4px;
      text-align:center;
      line-height:36px;
      font-size:16px;
      color:#fff;
      margin:24px 2px 0px 2px;
      border: 0;

      &.btn-submit { background:#00a0e9; }
      &.btn-cancel { background:#4f5b66; }
    }

  }
</style>